import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements AfterViewInit {

    displayedColumns: string[] = ['position', 'product', 'customer', 'price', 'vendor', 'date', 'status', 'rating'];
    dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

    @ViewChild(MatPaginator) paginator: MatPaginator;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    pending = true;
    outOfStock = true;
    delivered = true;

}

export interface PeriodicElement {
    customer: string;
    position: string;
    product: any;
    price: string;
    vendor: string;
    date: string;
    status: any;
    rating: any;
}

const ELEMENT_DATA: PeriodicElement[] = [
    {
        position: '#SK258',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product1.jpg',
        },
        customer: 'Colin Firth',
        price: '$289.50',
        vendor: 'UPA Campos Sales',
        date: '01-12-2022',
        status: {
            pending: 'Em análise'
        },
        rating: {
            star: '5.0',
            overall: '(61 Votes)'
        }
    },
    {
        position: '#AA257',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product2.jpg',
        },
        customer: 'Alina Smith',
        price: '$876.55',
        vendor: 'UPA Campos Sales',
        date: '02-12-2022',
        status: {
            outOfStock: 'Em espera'
        },
        rating: {
            star: '4.9',
            overall: '(55 Votes)'
        }
    },
    {
        position: '#BB256',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product3.jpg',
        },
        customer: 'James Andy',
        price: '$654.76',
        vendor: 'UPA Campos Sales',
        date: '03-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '4.0',
            overall: '(99 Votes)'
        }
    },
    {
        position: '#CC255',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product4.jpg',
        },
        customer: 'Sarah Taylor',
        price: '$654.99',
        vendor: 'UPA Campos Sales',
        date: '04-12-2022',
        status: {
            pending: 'Em análise'
        },
        rating: {
            star: '5.0',
            overall: '(196 Votes)'
        }
    },
    {
        position: '#DD254',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product5.jpg',
        },
        customer: 'David Warner',
        price: '$432.00',
        vendor: 'UPA Campos Sales',
        date: '05-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '3.0',
            overall: '(54 Votes)'
        }
    },
    {
        position: '#SK253',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product6.jpg',
        },
        customer: 'James Noah',
        price: '$100.00',
        vendor: 'UPA Campos Sales',
        date: '06-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '5.0',
            overall: '(100 Votes)'
        }
    },
    {
        position: '#SK252',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product7.jpg',
        },
        customer: 'William Benjamin',
        price: '$99.99',
        vendor: 'UPA Campos Sales',
        date: '07-12-2022',
        status: {
            outOfStock: 'Em espera'
        },
        rating: {
            star: '4.0',
            overall: '(99 Votes)'
        }
    },
    {
        position: '#SK251',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product8.jpg',
        },
        customer: 'Lucas Oliver',
        price: '$543.54',
        vendor: 'UPA Campos Sales',
        date: '08-12-2022',
        status: {
            pending: 'Em análise'
        },
        rating: {
            star: '3.5',
            overall: '(22 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product9.jpg',
        },
        customer: 'Ava Olivia',
        price: '$999.99',
        vendor: 'UPA Campos Sales',
        date: '09-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '4.5',
            overall: '(65 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product10.jpg',
        },
        customer: 'Isabella Sophia',
        price: '$321.99',
        vendor: 'UPA Campos Sales',
        date: '10-12-2022',
        status: {
            outOfStock: 'Em espera'
        },
        rating: {
            star: '5.0',
            overall: '(142 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product11.jpg',
        },
        customer: 'Mia Emma',
        price: '$500',
        vendor: 'UPA Campos Sales',
        date: '11-12-2022',
        status: {
            pending: 'Em análise'
        },
        rating: {
            star: '4.0',
            overall: '(10 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product12.jpg',
        },
        customer: 'Sophia Charlotte',
        price: '$199.21',
        vendor: 'UPA Campos Sales',
        date: '12-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '5.0',
            overall: '(15 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product13.jpg',
        },
        customer: 'Jackson Levi',
        price: '$99.99',
        vendor: 'UPA Campos Sales',
        date: '13-12-2022',
        status: {
            delivered: 'Paga'
        },
        rating: {
            star: '4.0',
            overall: '(54 Votes)'
        }
    },
    {
        position: '#SK248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product14.jpg',
        },
        customer: 'Samuel Logan',
        price: '$104.50',
        vendor: 'UPA Campos Sales',
        date: '14-12-2022',
        status: {
            pending: 'Em análise'
        },
        rating: {
            star: '3.0',
            overall: '(76 Votes)'
        }
    },
    {
        position: '#AB248',
        product: {
            productName: 'SUSAM',
            productImage: 'assets/img/recent-orders/product15.jpg',
        },
        customer: 'Gabriel Ezra',
        price: '$333.50',
        vendor: 'UPA Campos Sales',
        date: '15-12-2022',
        status: {
            outOfStock: 'Em espera'
        },
        rating: {
            star: '1.0',
            overall: '(98 Votes)'
        }
    },
];